"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            FilterDataType_Date: "Date",
            FilterDataType_DateTime: "DateTime",
            FilterDataType_Number: "Number",
            FilterDataType_Option: "Option",
            FilterDataType_String: "Text",
            FilterDataType_Time: "Time",
            FilterDisplayControl_AddField: "Add filter fields",
            FilterDisplayControl_Apply: "Apply",
            FilterDisplayControl_Clear: "Clear",
            FilterDisplayControl_DataSourceName: "Table",
            FilterDisplayControl_DataType: "Type",
            FilterDisplayControl_FieldName: "Field",
            FilterDisplayControl_RemoveField: "Remove filter on {0}",
            FilterDisplayControl_Reset: "Reset",
            FilterField_AddField: "Add",
            FilterOperators_BeginsWith: "begins with",
            FilterOperators_Between: "between",
            FilterOperators_Contains: "contains",
            FilterOperators_DoesNotContain: "does not contain",
            FilterOperators_GreaterThan: "after",
            FilterOperators_GreaterThan_Date: "after",
            FilterOperators_GreaterThanOrEqual: "greater than or equal",
            FilterOperators_Is: "is exactly",
            FilterOperators_Is_Date: "is exactly",
            FilterOperators_Is_Option: "is exactly",
            FilterOperators_IsEqualTo: "is equal to",
            FilterOperators_IsNot: "is not",
            FilterOperators_IsNot_Date: "is not",
            FilterOperators_IsNot_Option: "is not",
            FilterOperators_IsOneOf: "is one of",
            FilterOperators_IsOneOf_Option: "is one of",
            FilterOperators_LessThan: "before",
            FilterOperators_LessThan_Date: "before",
            FilterOperators_LessThanOrEqual: "less than or equal",
            FilterOperators_Matches: "matches",
            FilterOperators_Matches_Date: "matches",
            FilterOperators_Matches_Number: "matches",
            FilterOperators_Matches_Option: "matches",
            FilterOperators_NotEqualTo: "not equal to"
        }
    });
    var controls;
    (function (controls) {
        var FilterDisplay = /** @class */ (function (_super) {
            __extends(FilterDisplay, _super);
            function FilterDisplay(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                /**
                 * Executes the command to apply the filters.
                 */
                _this.applyFilters = function () {
                    var e_1, _a;
                    if ($dyn.value(_this.ShowApply) && $dyn.isObservable(_this.FilterExpression)) {
                        // We need to force the FilterExpression with the server when filters are applied. Related to fix for 1742547.
                        _this.FilterExpression.valueChanged.raise(undefined, true);
                    }
                    $dyn.util.applyfilterToTelemetry($dyn.value(_this.FieldExpressions), _this.previousExpressions, _this, $dyn.telemetry.ActionEvents.filterDisplayFilter);
                    if (!$dyn.value($dyn.ax.taskRecording.isRecording())) {
                        $dyn.callFunction(_this.ApplyFilters, _this, []);
                    }
                    else {
                        var filterOptions = [];
                        var filterExpression = $dyn.value(_this.FilterExpression);
                        try {
                            for (var filterExpression_1 = __values(filterExpression), filterExpression_1_1 = filterExpression_1.next(); !filterExpression_1_1.done; filterExpression_1_1 = filterExpression_1.next()) {
                                var currentFilterExpression = filterExpression_1_1.value;
                                var dataSourceName = $dyn.value(currentFilterExpression.DataSourceName);
                                var fieldName = $dyn.value(currentFilterExpression.FieldName);
                                var sfkReplacementFieldBinding = $dyn.value(currentFilterExpression.SFKReplacementFieldBinding);
                                var field = _this.getFieldCapability(dataSourceName, fieldName, sfkReplacementFieldBinding);
                                // If we are getting the field from capabilityList then only it should be added in Filter Expression
                                if (field) {
                                    var fieldLabel = field.FieldLabel;
                                    var displayDataType = $dyn.value(field.DisplayDataType);
                                    var values = currentFilterExpression.Values;
                                    var operator = currentFilterExpression.Operator;
                                    filterOptions.push({
                                        fieldLabel: fieldLabel,
                                        operatorLabel: $dyn.controls.FilterDisplay.GetOperatorLabel($dyn.value(operator), displayDataType),
                                        // Join the individual values with inner quotation marks and a comma
                                        values: $dyn.value(values).join("\",\"")
                                    });
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (filterExpression_1_1 && !filterExpression_1_1.done && (_a = filterExpression_1.return)) _a.call(filterExpression_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        $dyn.callFunction(_this.ApplyFilters, _this, ["", JSON.stringify(filterOptions)]);
                    }
                };
                /**
                 * Executes the command to reset the filters.
                 * @internal
                 */
                _this.resetFilters = function () {
                    var inputs = $(_this.element).find(".filterDisplayContent").find(".input_container");
                    // tslint:disable-next-line:prefer-for-of
                    for (var i = 0; i < inputs.length; i++) {
                        var control = $dyn.context(inputs[i]);
                        if (control && $dyn.value(control.IsValid) === false) {
                            // If any contained control is invalid, clear the value in the control to remove the control from the form's invalid list and remove any messages.
                            $dyn.setValue(control, "formattedValue", "", true);
                        }
                    }
                    _this.telemetryEventArgs = $dyn.telemetry.addControlActionEvent(_this, _this.telemetryEventArgs, $dyn.telemetry.ActionEvents.filterDisplayReset, {});
                    // reset the prefieldExpression
                    _this.previousExpressions = [];
                    $dyn.callFunction(_this.ResetFilters, _this, []);
                };
                /**
                 * Executes the command to add a filter field.
                 * @internal
                 */
                _this.addFilterField = function () {
                    if ($dyn.value(_this.ShowApply) && $dyn.isObservableArray(_this.FilterExpression)) {
                        // Force the FilterExpression to sync with the server when filters are going to be added, in case filters have been removed
                        // If 'Apply' filters button is shown, automatic syncing is disabled
                        _this.FilterExpression.valueChanged.raise(undefined, true);
                    }
                    $dyn.callFunction(_this.AddAFilterField, _this, []);
                };
                /**
                 * Handler for after the contained fields have completed rendering.
                 * @internal
                 */
                _this.postRenderFields = function () {
                    // After the fields are rendered, we need to set the max-height of the field container. This allows the 'Apply' and 'Clear' buttons to float down with
                    // expanding content until they reach the bottom of the form.
                    _this.setFieldContainerSizing();
                };
                _this.Capabilities = $dyn.observableObject(_this.CapabilityList);
                _this.capabilitiesFlatList = $dyn.computed(function () {
                    var e_2, _a, e_3, _b;
                    var fieldList = [];
                    var capabilities = $dyn.value(_this.CapabilityList);
                    try {
                        for (var capabilities_1 = __values(capabilities), capabilities_1_1 = capabilities_1.next(); !capabilities_1_1.done; capabilities_1_1 = capabilities_1.next()) {
                            var dataSourceCapability = capabilities_1_1.value;
                            var dataSourceLabel = $dyn.value(dataSourceCapability.DataSourceLabel) ? $dyn.value(dataSourceCapability.DataSourceLabel) : $dyn.value(dataSourceCapability.DataSourceName);
                            try {
                                for (var _c = (e_3 = void 0, __values(dataSourceCapability.Fields)), _d = _c.next(); !_d.done; _d = _c.next()) {
                                    var fieldCapability = _d.value;
                                    var dataTypeLabel = $dyn.value(fieldCapability.ShowLookup) ? $dyn.label("FilterDataType_Option")
                                        : $dyn.controls.FilterDisplay.GetDataTypeLabel($dyn.value(fieldCapability.DisplayDataType));
                                    var fieldLabel = $dyn.value(fieldCapability.FieldLabel) ? $dyn.value(fieldCapability.FieldLabel) : $dyn.value(fieldCapability.FieldName);
                                    fieldList.push({
                                        DataSourceLabel: dataSourceLabel,
                                        DataSourceName: $dyn.value(dataSourceCapability.DataSourceName),
                                        DataTypeLabel: dataTypeLabel,
                                        DisplayDataType: $dyn.value(fieldCapability.DisplayDataType),
                                        FieldArrayIndex: $dyn.util.getAxArrayFieldIndex(parseInt($dyn.value(fieldCapability.FieldId), 10)),
                                        FieldLabel: fieldLabel,
                                        FieldName: $dyn.value(fieldCapability.FieldName),
                                        MasterFormDataSourceName: $dyn.value(dataSourceCapability.MasterFormDataSourceName),
                                        SFKReplacementFieldBinding: $dyn.value(fieldCapability.SFKReplacementFieldBinding),
                                        TableId: $dyn.value(fieldCapability.TableId)
                                    });
                                }
                            }
                            catch (e_3_1) { e_3 = { error: e_3_1 }; }
                            finally {
                                try {
                                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                                }
                                finally { if (e_3) throw e_3.error; }
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (capabilities_1_1 && !capabilities_1_1.done && (_a = capabilities_1.return)) _a.call(capabilities_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    return fieldList;
                });
                _this.FieldExpressions = $dyn.computed(function () {
                    if ($dyn.length(_this.Capabilities) === 0) {
                        return [];
                    }
                    else {
                        return $dyn.value(_this.Expression);
                    }
                });
                _this.LayoutHeight = $dyn.computed(function () {
                    // FilterDisplay 'auto' and 'sizeToContent' sizing should be 'sizeToAvailable'
                    var height = $dyn.value(_this.Height);
                    if (height === $dyn.ui.autoValue || height === $dyn.layout.Size.content) {
                        height = $dyn.layout.Size.available;
                    }
                    return height;
                }, function (value) {
                    $dyn.setValue(_this, "Height", value);
                });
                if ($dyn.value(_this.ShowApply)) {
                    // If the 'Apply' button is shown we only need to sync the FilterExpression with the server when filters are applied.
                    _this.Expression = $dyn.observableObject(_this.FilterExpression);
                }
                else {
                    _this.Expression = $dyn.observableObject(_this.FilterExpression, true);
                }
                _this.previousExpressions = [];
                $dyn.util.fieldExpressionAppend(_this.Expression, _this.previousExpressions);
                $dyn.observe(_this.FieldExpressions, function () {
                    // If the previous FilterExpression was empty, take a snapshot of the new FilterExpression to use to
                    // determine changes to the FilterExpression for telemetry purposes
                    if (_this.previousExpressions.length === 0) {
                        $dyn.util.fieldExpressionAppend(_this.Expression, _this.previousExpressions);
                    }
                });
                // The filterDisplay needs to have it's unique layout code run after the layout bindings have been applied, and on window resize.
                $(window).resize(_this.setFieldContainerSizing);
                _this.usingDisposable($dyn.observe($dyn.ui.layout, _this.postRenderFields));
                return _this;
            }
            FilterDisplay.prototype.removeFilterExpression = function (expression) {
                var foundIndex = $dyn.value(this.Expression).indexOf(expression);
                if (foundIndex >= 0) {
                    this.Expression.splice(foundIndex, 1);
                    // focus the last field
                    var field_1 = this.getLastField();
                    this.previousExpressions.push($dyn.util.fieldExpressionSimpleCopy(expression));
                    if (field_1) {
                        $dyn.microTask(function () {
                            $dyn.log.focus && $dyn.log.focus("Focus: Filter-> focus the last field after removing a filter");
                            $(field_1).focus();
                        });
                    }
                    else {
                        $dyn.microTask(function () {
                            $dyn.log.focus && $dyn.log.focus("Focus: Filter-> no filter to focus, so focusing the add filter button");
                            $("[Name=SystemDefinedFilterPane_FilterDisplay_AddFilterField]").focus();
                        });
                    }
                }
            };
            /**
             * Find the FieldCapability for the given field.
             * @internal
             * @param dataSourceName The name of the datasource
             * @param fieldName The name of the field
             * @param sfkReplacementFieldBinding The Base64 encoding of the packed RelativeFieldBinding representing the surrogate FKs replacement field.
             */
            FilterDisplay.prototype.getFieldCapability = function (dataSourceName, fieldName, sfkReplacementFieldBinding) {
                var capabilityList = $dyn.value(this.CapabilityList);
                var capability = this.getCapability(capabilityList, dataSourceName);
                var capabilityFields = capability
                    ? capability.Fields
                    : null;
                var field = this.getField($dyn.value(capabilityFields), fieldName, sfkReplacementFieldBinding);
                return field;
            };
            FilterDisplay.prototype.dispose = function () {
                $(window).off("resize", this.setFieldContainerSizing);
                _super.prototype.dispose.call(this);
            };
            /**
             * Find the displayDataType of a field, given dataSourceName and fieldName
             * @internal
             * @deprecated This is deprecated at 08/05/2020.Remove it TFS(478168).
             * @param dataSourceName The name of the datasource
             * @param fieldName The name of the field
             */
            FilterDisplay.prototype.displayDataType = function (dataSourceName, fieldName) {
                var e_4, _a, e_5, _b;
                // TODO: Can this be deleted? Are there any consumers of this anymore?
                var displayDataType = "";
                var dataSources = $dyn.value(this.Capabilities);
                if (dataSources) {
                    try {
                        for (var dataSources_1 = __values(dataSources), dataSources_1_1 = dataSources_1.next(); !dataSources_1_1.done; dataSources_1_1 = dataSources_1.next()) {
                            var dataSource_1 = dataSources_1_1.value;
                            if (dataSource_1 && $dyn.value(dataSource_1.DataSourceName) === dataSourceName) {
                                try {
                                    for (var _c = (e_5 = void 0, __values($dyn.value(dataSource_1.Fields))), _d = _c.next(); !_d.done; _d = _c.next()) {
                                        var field = _d.value;
                                        if ($dyn.value(field.FieldName === fieldName)) {
                                            displayDataType = $dyn.value(field.DisplayDataType);
                                        }
                                    }
                                }
                                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                                finally {
                                    try {
                                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                                    }
                                    finally { if (e_5) throw e_5.error; }
                                }
                            }
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (dataSources_1_1 && !dataSources_1_1.done && (_a = dataSources_1.return)) _a.call(dataSources_1);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                }
                return displayDataType;
            };
            /**
             * The flyout Subscriber for when escape is pressed. In this case we want to focus the add button
             * @deprecated This is deprecated at 08/05/2020.Remove it TFS(478168).
             */
            FilterDisplay.prototype.flyoutEscapeSubscriber = function () {
                $dyn.util.flyout.defaultFlyoutEscapeSubscriber();
                var addButton = this.element.getElementsByClassName("filterDisplay-addFieldControl");
                var root = this.Root;
                if (addButton && addButton.length > 0) {
                    $dyn.async(function () {
                        if ($dyn.log.focus) {
                            var control = $dyn.context($(addButton)[0]);
                            $dyn.log.focus("Focus: Filter-> esc add field flyout set add button focused " + control.Id);
                        }
                        var controlName = addButton[0].getAttribute("data-dyn-controlname");
                        root.ActiveControl(controlName);
                    });
                }
            };
            /**
             * Set the max-height of the field container so that only that container element will scroll.
             */
            FilterDisplay.prototype.setFieldContainerSizing = function () {
                // get the active filterdisplay because this can come from filter or from the window event
                var activeForm = $dyn.shell.getActiveForm();
                var activeFormContext;
                if (activeForm) {
                    activeFormContext = $dyn.context(activeForm);
                }
                if (activeFormContext && activeFormContext.FilterPaneControl && activeFormContext.FilterPaneControl.element) {
                    var fieldContainer = $(activeFormContext.FilterPaneControl.element).find(".filterDisplayContent")[0];
                    if (fieldContainer) {
                        var filterPaneTitle = $(activeFormContext.FilterPaneControl.element).find(".filterPaneTitle")[0];
                        var filterTitleWidth = filterPaneTitle ? $(filterPaneTitle).outerHeight(true) : 0;
                        if ($dyn.util.isInZoomHeightMode()) {
                            // clear height as we want the entire filterpane to scroll instead
                            $(fieldContainer).css("max-height", "");
                        }
                        else {
                            var totalHeight = $(activeForm).innerHeight();
                            var buttonContainer = $(fieldContainer).siblings(".filterDisplayButtonContainer");
                            var maxContainerHeight = totalHeight - buttonContainer.outerHeight(true) - filterTitleWidth;
                            maxContainerHeight = maxContainerHeight > 0 ? maxContainerHeight : 0;
                            $(fieldContainer).css("max-height", maxContainerHeight);
                        }
                    }
                }
            };
            /**
             * Given a FieldCapability, generate a FieldFilterExpression.
             * @param fieldCapability The field capability
             */
            FilterDisplay.prototype._generateFieldExpression = function (fieldCapability) {
                // Given a fieldCapability, generate a fieldExpression. This is used when adding a filter field to the filterDisplay
                var fieldExpression;
                if (fieldCapability) {
                    var operator = $dyn.controls.FilterField.Operators.is;
                    if (fieldCapability.DisplayDataType === $dyn.controls.FilterField.DataTypes.String) {
                        operator = $dyn.controls.FilterField.Operators.beginsWith;
                    }
                    else if (fieldCapability.DisplayDataType === $dyn.controls.FilterField.DataTypes.Date ||
                        fieldCapability.DisplayDataType === $dyn.controls.FilterField.DataTypes.UtcDateTime ||
                        fieldCapability.DisplayDataType === $dyn.controls.FilterField.DataTypes.Time) {
                        operator = $dyn.controls.FilterField.Operators.between;
                    }
                    fieldExpression = {
                        Capability: null,
                        DataSourceName: $dyn.value(fieldCapability.DataSourceName),
                        FieldArrayIndex: $dyn.value(fieldCapability.FieldArrayIndex),
                        FieldName: $dyn.value(fieldCapability.FieldName),
                        FormDataSourceName: "",
                        IsEditable: "Yes",
                        IsQueryFilter: "Yes",
                        MasterFormDataSourceName: $dyn.value(fieldCapability.MasterFormDataSourceName),
                        Operator: operator,
                        RecordingReferences: [],
                        SFKReplacementFieldBinding: $dyn.value(fieldCapability.SFKReplacementFieldBinding),
                        TableId: $dyn.value(fieldCapability.TableId),
                        Values: [""],
                    };
                }
                return fieldExpression;
            };
            /**
             * finds the last filter field
             */
            FilterDisplay.prototype.getLastField = function () {
                var lastField;
                var filterFields = this.element.getElementsByClassName("filterField");
                var nuberOfFields = filterFields.length;
                if (nuberOfFields > 0) {
                    // get the last field
                    var container = filterFields[nuberOfFields - 1].getElementsByClassName("input_container");
                    if (container && container.length > 0) {
                        var field = container[0].getElementsByClassName("field");
                        if (field && field.length > 0) {
                            lastField = field[0];
                        }
                    }
                }
                return lastField;
            };
            /**
             * finds the last filter field
             * below misspelled function is kept for backward compatibility, as it was in old filtering.js file. Use getLastField instead.
             * @deprecated This is deprecated at 08/05/2020.Remove it TFS(478168).
             */
            FilterDisplay.prototype.getLastFileld = function () {
                return this.getLastField();
            };
            /**
             * finds the capability from data source name
             */
            FilterDisplay.prototype.getCapability = function (capList, sourceName) {
                var e_6, _a;
                if (!Array.isArray(capList)) {
                    return null;
                }
                try {
                    for (var capList_1 = __values(capList), capList_1_1 = capList_1.next(); !capList_1_1.done; capList_1_1 = capList_1.next()) {
                        var currentCap = capList_1_1.value;
                        if (currentCap.DataSourceName === sourceName) {
                            return currentCap;
                        }
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (capList_1_1 && !capList_1_1.done && (_a = capList_1.return)) _a.call(capList_1);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
                return null;
            };
            FilterDisplay.prototype.getField = function (capFields, name, fieldBinding) {
                var e_7, _a;
                if (!Array.isArray(capFields)) {
                    return null;
                }
                try {
                    for (var capFields_1 = __values(capFields), capFields_1_1 = capFields_1.next(); !capFields_1_1.done; capFields_1_1 = capFields_1.next()) {
                        var currentCapField = capFields_1_1.value;
                        if (currentCapField.FieldName === name && currentCapField.SFKReplacementFieldBinding === fieldBinding) {
                            return currentCapField;
                        }
                    }
                }
                catch (e_7_1) { e_7 = { error: e_7_1 }; }
                finally {
                    try {
                        if (capFields_1_1 && !capFields_1_1.done && (_a = capFields_1.return)) _a.call(capFields_1);
                    }
                    finally { if (e_7) throw e_7.error; }
                }
                return null;
            };
            return FilterDisplay;
        }($dyn.ui.Container));
        controls.FilterDisplay = FilterDisplay;
        FilterDisplay.prototype.AddAFilterField = null;
        FilterDisplay.prototype.ApplyFilters = null;
        FilterDisplay.prototype.CapabilityList = [];
        FilterDisplay.prototype.FilterExpression = [];
        FilterDisplay.prototype.Height = $dyn.layout.Size.available;
        FilterDisplay.prototype.HideFilters = null;
        FilterDisplay.prototype.ResetFilters = null;
        FilterDisplay.prototype.ShowAddFilter = false;
        FilterDisplay.prototype.ShowApply = false;
        FilterDisplay.prototype.ShowClear = false;
        FilterDisplay.prototype.ShowFilters = null;
        (function (FilterDisplay) {
            /**
             * Fetch the label to show in the UI representing the datatype of a field.
             * @internal
             * @param dataType The dataType.
             * @returns data type label
             */
            function GetDataTypeLabel(dataType) {
                var label = "";
                switch (dataType) {
                    case $dyn.controls.FilterField.DataTypes.Date:
                        label = $dyn.label("FilterDataType_Date");
                        break;
                    case $dyn.controls.FilterField.DataTypes.Time:
                        label = $dyn.label("FilterDataType_Time");
                        break;
                    case $dyn.controls.FilterField.DataTypes.UtcDateTime:
                        label = $dyn.label("FilterDataType_DateTime");
                        break;
                    case $dyn.controls.FilterField.DataTypes.Integer:
                    case $dyn.controls.FilterField.DataTypes.Int64:
                    case $dyn.controls.FilterField.DataTypes.Real:
                        label = $dyn.label("FilterDataType_Number");
                        break;
                    case $dyn.controls.FilterField.DataTypes.Enum:
                        label = $dyn.label("FilterDataType_Option");
                        break;
                    default:
                        label = $dyn.label("FilterDataType_String");
                        break;
                }
                return label;
            }
            FilterDisplay.GetDataTypeLabel = GetDataTypeLabel;
            /**
             * Fetch the label to show in the UI representing the filter operator for the given field datatype.
             * @internal
             * @param operator The operator.
             * @param dataType The dataType.
             * @returns The label to show in the UI representing the filter operator
             */
            function GetOperatorLabel(operator, dataType) {
                var label = "";
                switch (operator) {
                    case controls.FilterField.Operators.matches:
                        {
                            switch (dataType) {
                                case controls.FilterField.DataTypes.Integer:
                                case controls.FilterField.DataTypes.Int64:
                                case controls.FilterField.DataTypes.Real:
                                    label = $dyn.label("FilterOperators_Matches_Number");
                                    break;
                                case controls.FilterField.DataTypes.Date:
                                case controls.FilterField.DataTypes.UtcDateTime:
                                case controls.FilterField.DataTypes.Time:
                                    label = $dyn.label("FilterOperators_Matches_Date");
                                    break;
                                case controls.FilterField.DataTypes.Enum:
                                    label = $dyn.label("FilterOperators_Matches_Option");
                                    break;
                                default:
                                    label = $dyn.label("FilterOperators_Matches");
                                    break;
                            }
                        }
                        break;
                    case controls.FilterField.Operators.is:
                        {
                            switch (dataType) {
                                case controls.FilterField.DataTypes.Integer:
                                case controls.FilterField.DataTypes.Int64:
                                case controls.FilterField.DataTypes.Real:
                                    label = $dyn.label("FilterOperators_IsEqualTo");
                                    break;
                                case controls.FilterField.DataTypes.Date:
                                case controls.FilterField.DataTypes.UtcDateTime:
                                case controls.FilterField.DataTypes.Time:
                                    label = $dyn.label("FilterOperators_Is_Date");
                                    break;
                                case controls.FilterField.DataTypes.Enum:
                                    label = $dyn.label("FilterOperators_Is_Option");
                                    break;
                                default:
                                    label = $dyn.label("FilterOperators_Is");
                                    break;
                            }
                        }
                        break;
                    case controls.FilterField.Operators.isNot:
                        {
                            switch (dataType) {
                                case controls.FilterField.DataTypes.Integer:
                                case controls.FilterField.DataTypes.Int64:
                                case controls.FilterField.DataTypes.Real:
                                    label = $dyn.label("FilterOperators_NotEqualTo");
                                    break;
                                case controls.FilterField.DataTypes.Date:
                                case controls.FilterField.DataTypes.UtcDateTime:
                                case controls.FilterField.DataTypes.Time:
                                    label = $dyn.label("FilterOperators_IsNot_Date");
                                    break;
                                case controls.FilterField.DataTypes.Enum:
                                    label = $dyn.label("FilterOperators_IsNot_Option");
                                    break;
                                default:
                                    label = $dyn.label("FilterOperators_IsNot");
                                    break;
                            }
                        }
                        break;
                    case controls.FilterField.Operators.contains:
                        label = $dyn.label("FilterOperators_Contains");
                        break;
                    case controls.FilterField.Operators.doesNotContain:
                        label = $dyn.label("FilterOperators_DoesNotContain");
                        break;
                    case controls.FilterField.Operators.beginsWith:
                        label = $dyn.label("FilterOperators_BeginsWith");
                        break;
                    case controls.FilterField.Operators.isOneOf:
                        {
                            switch (dataType) {
                                case controls.FilterField.DataTypes.Enum:
                                    label = $dyn.label("FilterOperators_IsOneOf_Option");
                                    break;
                                default:
                                    label = $dyn.label("FilterOperators_IsOneOf");
                                    break;
                            }
                        }
                        break;
                    case controls.FilterField.Operators.greaterThan:
                        {
                            switch (dataType) {
                                case controls.FilterField.DataTypes.Date:
                                case controls.FilterField.DataTypes.UtcDateTime:
                                case controls.FilterField.DataTypes.Time:
                                    label = $dyn.label("FilterOperators_GreaterThan_Date");
                                    break;
                                default:
                                    label = $dyn.label("FilterOperators_GreaterThan");
                                    break;
                            }
                        }
                        break;
                    case controls.FilterField.Operators.lessThan:
                        {
                            switch (dataType) {
                                case controls.FilterField.DataTypes.Date:
                                case controls.FilterField.DataTypes.UtcDateTime:
                                case controls.FilterField.DataTypes.Time:
                                    label = $dyn.label("FilterOperators_LessThan_Date");
                                    break;
                                default:
                                    label = $dyn.label("FilterOperators_LessThan");
                                    break;
                            }
                        }
                        break;
                    case controls.FilterField.Operators.greaterThanOrEqual:
                        label = $dyn.label("FilterOperators_GreaterThanOrEqual");
                        break;
                    case controls.FilterField.Operators.lessThanOrEqual:
                        label = $dyn.label("FilterOperators_LessThanOrEqual");
                        break;
                    case controls.FilterField.Operators.between:
                        label = $dyn.label("FilterOperators_Between");
                        break;
                }
                return label;
            }
            FilterDisplay.GetOperatorLabel = GetOperatorLabel;
        })(FilterDisplay = controls.FilterDisplay || (controls.FilterDisplay = {}));
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=FilterDisplay.js.map
